import { render } from "./global_table.html?vue&type=template&id=22d19d5f&external"
import script from "./global_table.js?vue&type=script&lang=js&external"
export * from "./global_table.js?vue&type=script&lang=js&external"

import "./GlobalTable.vue?vue&type=style&index=0&id=22d19d5f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__